import React from "react";
import styled, { css } from "styled-components";
import { SvgCheck } from "../Svgs/Check";

const CheckIcon = styled(SvgCheck)`
  height: 12px;
  width: 12px;
`;

const Container = styled.div`
  height: 14px;
  width: 14px;
  border: 1px solid ${(props) => props.theme.colors.black20};
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.5);
  ${(props: any) =>
    props.isSelected &&
    css`
      border: 1px solid white;
      background-color: ${(props) => props.theme.colors.navy};
    `};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-shrink: 0;
  flex-grow: 0;
  color: #fff;
  svg {
    fill: #fff;
  }
`;

type Props = {
  isSelected: boolean;
  icon?: any;
};
export const CheckboxInput = ({ isSelected, icon = null, ...props }: Props) => {
  return (
    <Container {...{ isSelected, ...props }}>
      {isSelected && (icon || <CheckIcon />)}
    </Container>
  );
};
